import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
`

export const Row = styled.div`
  display: flex;
  gap: 8px;
`

export const Input = styled.input<{ $error?: boolean }>`
  flex: 1;
  min-width: 0;
  height: 44px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 14px;
  text-transform: uppercase;
  color: #0f172a;
  background: #fff;
  border: 1.5px solid ${({ $error }) => ($error ? "#DC2626" : "#E2E8F0")};

  &:focus {
    outline: none;
    border-color: ${({ $error, theme }) =>
      $error ? "#DC2626" : theme.colors.blue.main};
  }
`

export const Button = styled.button`
  height: 44px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blue.main};
  background: #fff;
  border: 1.5px solid ${({ theme }) => theme.colors.blue.main};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const Error = styled.span`
  font-size: 13px;
  line-height: 1.4;
  color: #dc2626;
`

export const Applied = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  color: #166534;
  background: #f0fdf4;
  border: 1.5px solid #bbf7d0;

  button {
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #dc2626;
    background: none;
    border: none;
  }
`
